// pages/FormViewerPage/services/formViewerService/funnelGoogle.ts — event funnel Google (split dari funnelEvents.ts)
import type { FunnelEventParams } from './funnelTypes';
import { hasFiredSessionKey, markFiredSessionKey } from './funnelSession';

// Tembak event funnel Google (gtag) — idempoten per sesi tab.
// gtag dimuat MultiPlatformPixelScript bila ada config google. Kalau SDK belum
// siap (autofill cepat: nama+WA valid sebelum gtag ter-inject) → RETRY 1x, jangan
// tandai sesi dulu (pola sama TikTok) supaya event tidak hilang permanen.
export function fireFunnelGoogleEvent(
    pixelIds: string[],
    eventName: 'add_to_cart' | 'begin_checkout',
    params: FunnelEventParams,
    sessionKey: string,
    retriesLeft: number = 3
): boolean {
    try {
        if (!pixelIds || pixelIds.length === 0) return false;
        if (hasFiredSessionKey(sessionKey)) return false;
        const gtag = (window as any).gtag;
        if (typeof gtag !== 'function') {
            // Retry BERBATAS (3x) — tidak menandai sesi, jadi tidak hilang permanen
            // tapi juga tidak menggantung kalau SDK memang tidak pernah ada.
            if (retriesLeft > 0) {
                setTimeout(() => fireFunnelGoogleEvent(pixelIds, eventName, params, sessionKey, retriesLeft - 1), 2500);
            }
            return false;
        }
        for (const id of pixelIds) {
            const t = id?.trim();
            if (!t) continue;
            try { gtag('config', t); } catch { /* abaikan */ }
        }
        gtag('event', eventName, {
            currency: 'IDR',
            ...(params.value !== undefined ? { value: params.value } : {}),
        });
        markFiredSessionKey(sessionKey);
        return true;
    } catch { return false; }
}
